/**
 * Front-end model representing an organization. See back-end complement for field descriptions.
 *
 * The following Field model attribute sets are located under the static `fields` attribute.
 * * PrimaryName
 * * SecondaryName
 * * Address
 * * PhoneNumber
 * * EmailAddress
 * * Status
 * * background-image
 * * header-color
 * @module app/models/Organization
 */
import Backbone from "backbone";
import _ from "underscore";
import UserCollection from "app/models/UserCollection";
import Enums from "app/enums";
import Document from "app/models/Document";
import RequestUtils from "app/utils/RequestUtils";
import ErrorUtils from "app/utils/ErrorUtils";
import FieldUtils from "app/utils/FieldUtils";
import urlService from "app/UrlService";
export default Backbone.Model.extend(
  {
    defaults: {
      PrimaryName: "",
      SecondaryName: "",
      Address: "",
      PhoneNumber: "",
      EmailAddress: "",
      Status: "normal",
    },

    /**
     * Gets the users in this organization.
     * @param  {Function} callback Function expecting a single argument, which is a `UserCollection` containing the users in this organization.
     * @param  {Boolean}   refresh  True to force a refresh from the server.
     * @async
     */
    getUsers: function (callback, refresh) {
      if (this._users && !refresh) {
        callback(null, this._users);
      } else {
        RequestUtils.get(
          urlService.apiurl("organization/" + this.id + "/users", true),
          _.bind(function (data) {
            this._users = new UserCollection(data);
            callback(null, this._users);
          }, this)
        ).fail(function (jqXHR) {
          callback(ErrorUtils.normalizeError({}, jqXHR));
        });
      }
    },
  },
  {
    fields: {
      name: FieldUtils.fieldPrototype("PrimaryName", "Name", "text"),
      PrimaryName: FieldUtils.fieldPrototype("PrimaryName", "Name", "text"),
      SecondaryName: FieldUtils.fieldPrototype(
        "SecondaryName",
        "Secondary Name",
        "text"
      ),
      Address: FieldUtils.fieldPrototype("Address", "Address", "text"),
      PhoneNumber: FieldUtils.fieldPrototype(
        "PhoneNumber",
        "Phone Number",
        "phone"
      ),
      EmailAddress: FieldUtils.fieldPrototype(
        "EmailAddress",
        "Email Address",
        "email"
      ),
      Status: FieldUtils.fieldPrototype("Status", "Status", null, {
        values: [
          {
            value: "pending",
            text: "Pending",
          },
          {
            value: "deleted",
            text: "Deleted",
          },
          {
            value: "locked",
            text: "Locked",
          },
          {
            value: "normal",
            text: "Normal",
          },
        ],
      }),
      "background-image": FieldUtils.fieldPrototype(
        "background-image",
        "Background Image",
        "image",
        {
          viewOptions: {
            fileOptions: {
              Visibility: Enums.FileVisibility.Public,
            },
            documentFactory: Document.getFactory(),
            urlBuilder: urlService.apiBuilder,
          },
        }
      ),
      "header-color": FieldUtils.fieldPrototype(
        "header-color",
        "Header Color",
        "color",
        {
          viewOptions: {
            manualEntry: true,
          },
        }
      ),
    },
    HBK: "547e01032361e520ecc0ddc7",
  }
);



//////////////////
// WEBPACK FOOTER
// ./public/js/app/models/Organization.js
// module id = 107
// module chunks = 1